import { useMaxSemester } from "../CurriculumContext";
import { HoursInput, SemesterInput } from "./Partials";

// A discipline is not scheduled past its exam semester or the curriculum's length; 0 means grade after cycle.
const ScheduleFields = ({ finalExamInSemester }) => {
  const maxSemester = useMaxSemester();
  const isBoundByExam = finalExamInSemester > 0 && finalExamInSemester <= maxSemester;

  return (
    <>
      <SemesterInput
        md={12}
        max={isBoundByExam ? finalExamInSemester : maxSemester}
        helperText={isBoundByExam ? `От 1 до ${finalExamInSemester} (семестър на изпита)` : undefined}
      />

      <HoursInput
        source="lecturesPerSemester"
        label="Часове лекции на семестър"
        md={6}
        isRequired
      />
      <HoursInput
        source="seminarExercisesPerSemester"
        label="Часове СУ на семестър"
        md={6}
      />
      <HoursInput
        source="laboratoryExercisesPerSemester"
        label="Часове ЛУ на семестър"
        md={6}
      />
      <HoursInput
        source="practicalExercisesPerSemester"
        label="Часове ПУ на семестър"
        md={6}
      />
    </>
  );
};

export default ScheduleFields;
